<!-- ----------------------------------------------- -->
<template>
  <v-card class="com-pc-card tm-pc-curt-card">
    <v-row class="com-pc-card-header" v-show="pcPanelMode">
      <div class="com-pc-card-title">
        {{ text.title }} {{ tmRdBsnList.curt.obsTime }}
      </div>
    </v-row>
    <v-row class="com-pc-card-contents" no-gutters>
      <v-col
        v-for="obs in tmRdBsnList.curt.category"
        :key="obs.name"
        class="ma-2"
      >
        <v-sheet outlined class="tm-pc-current-data-box">
          <v-row no-gutters>
            <div
              class="tm-pc-current-label tm-pc-rain-color"
              :bg-color="obs.bgColor"
            >
              {{ obs.title }}
            </div>
          </v-row>
          <v-divider></v-divider>
          <v-row class="card" no-gutters justify="center">
              {{ obs.value }}
              {{ obs.unit }}
          </v-row>
        </v-sheet>
      </v-col>
    </v-row>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [PC]レーダ流域 最新観測値カード
 * TmRdBsnCurt.vue
 * @author ILUKE
 */

export default {
  name: "tm-rd-bsn-curt",
  data() {
    return {
      /** 文字列リソース */
      text: {
        title: "最新観測値",
      },
    };
  },
  computed: {
    /**
     * レーダ流域 取得
     */
    tmRdBsnList: {
      get() {
        return this.$store.state.Telemeter.selectedTm;
      },
    },
    /** フレームの拡大・縮小判定用 */
    pcPanelMode: {
      get() {
        return this.$store.state.app.pcPanelMode;
      },
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
